<template>
  <div class="space-y-6">
    <div v-if="loadError" class="rounded-md border border-red-200 bg-red-50 p-8 text-center">
      <div class="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-100">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="text-red-500">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
          <path d="M10 10l4 4m0 -4l-4 4" />
        </svg>
      </div>
      <h3 class="m-0 mb-1 p-0 text-sm font-medium text-red-900">Could not load maintenance data</h3>
      <p class="mb-0 text-sm text-red-700">{{ loadError }}</p>
    </div>

    <template v-else>
      <bulk-maintenance-panel
        :company-id="companyId"
        :tree="tree"
        :loading="loading"
        :should-notify-default="shouldNotifyDefault"
        :require-comment="requireComment"
        @applied="fetchTree(true)"
      />

      <active-maintenance-windows
        :company-id="companyId"
        :active-groups="activeGroups"
        :loading="loading"
        :should-notify-default="shouldNotifyDefault"
        @disabled="fetchTree(true)"
      />
    </template>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BulkMaintenanceMode",
  props: {
    companyId: { type: String, required: true },
    shouldNotifyDefault: { type: Boolean, default: true },
    requireComment: { type: Boolean, default: false },
  },
  data() {
    return {
      tree: [],
      activeGroups: [],
      loading: true,
      loadError: null,
    };
  },
  mounted() {
    this.fetchTree();
  },
  methods: {
    fetchTree(silent = false) {
      if (!silent) this.loading = true;
      axios
        .get(`/api-internal/${this.companyId}/maintenance/bulk`)
        .then((r) => {
          this.tree = r.data.areas;
          this.activeGroups = r.data.active_groups ?? [];
          this.loadError = null;
        })
        .catch(() => {
          this.loadError = "Failed to load points. Please refresh the page.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
